import * as braze from '@braze/web-sdk';

type IReminderItem = {
    paId: number;
    listingId?: number;
    reminderId?: string;
};

export const reminderItemMixpanelProperties = (itemCategory: string, item: any, selectedChannel: any) => {
    return itemCategory === 'VOD'
        ? {
              'VOD Name': item?.name || '',
              'VOD Year': item?.year || '',
              'VOD Rating': item?.ratings || '',
              'VOD Type': item?.programType || '',
              'VOD Genre': Array.isArray(item?.genre) ? item.genre.join(', ') : item?.genre || '',
              'VOD AssetID': item?.paId || '',
              GUID: item?.guid || '',
              'VOD Provider': Array.isArray(item?.provider) ? item.provider.join(', ') : item?.provider || '',
              'VOD Category': Array.isArray(item?.tags)
                  ? item.tags
                        .map((tag) => (tag?.scheme === 'Categories' ? tag?.title || null : null))
                        .filter((tag) => !!tag)
                        .join(', ')
                  : item?.tags || '',
          }
        : item?.isPpv
        ? {
              'Event Title': item?.name,
              'Event ID': item?.eventId,
          }
        : {
              'Channel Number': selectedChannel?.channelNumber,
              'Channel Name': selectedChannel?.channelTitle,
              'Channel Category': Array.isArray(selectedChannel?.category)
                  ? selectedChannel.category.join(', ')
                  : selectedChannel?.category || '',
              'Program Name': item?.title || '',
              'PA ID': item?.paId || '',
              'Listing ID': item?.listingId || '',
              'Video Codec': 'H.264',
          };
};

export function reminderMatchesItem(
    reminder: IReminderItem,
    paId: number | string,
    listingId: number | string
): boolean {
    if (listingId) {
        return reminder.paId == paId && reminder.listingId == listingId;
    }
    // VOD items without listingId — match by paId only when reminder has no listingId
    return reminder.paId == paId && !reminder.listingId;
}

export function checkIfReminderExists(reminders: IReminderItem[], paId: number | string, listingId: number | string) {
    return reminders.length > 0 && reminders.some((reminder) => reminderMatchesItem(reminder, paId, listingId));
}

export function excludeIdFromUrl(url: string) {
    if (typeof url !== 'string') return url;
    const path = url.split('?')[0];
    return path.split('/').pop();
}

export function findRemindId(reminders: IReminderItem[], paId: number | string, listingId: number | string) {
    return reminders.find((reminder) => reminderMatchesItem(reminder, paId, listingId))?.reminderId;
}

export const isNotificationBlocked = () => {
    return braze.isPushSupported() === false || braze.isPushBlocked() ? true : false;
};

export function makeArrayUniqueBasedOnPaId(array: IReminderItem[]) {
    return array.reduce((acc: IReminderItem[], curr: IReminderItem) => {
        // Check if the paId already exists in the accumulator array
        const isExist = acc.some((item) => item.paId === curr.paId);
        // If it doesn't exist, push the current object to the accumulator array
        if (!isExist) {
            acc.push(curr);
        }
        return acc;
    }, []);
}
